module.exports = __webpack_public_path__ + "img/CS48Q-中_04.8c407917.jpg";